<form [formGroup]="timesheetForm" class="tw-cursor">
    <div class="tw-text-center tw-grid tw-grid-cols-10 tw-gap-2">
        <div
            [matTooltip]="tooltipText()"
            matTooltipPosition="after"
            class="tw-text-left tw-flex-col tw-min-w-0 tw-justify-center tw-flex tw-flex-auto tw-max-w-96 tw-w-full tw-col-span-2"
        >
            <div
                class="tw-whitespace-nowrap tw-flex-initial tw-text-ellipsis tw-overflow-hidden"
            >
                <span>{{ timesheetForm.controls.clientName.value }}</span>
            </div>

            <mat-divider></mat-divider>

            <div
                class="tw-whitespace-nowrap tw-flex-initial tw-text-ellipsis tw-overflow-hidden"
            >
                <span>{{ timesheetForm.controls.projectName.value }}</span>
            </div>

            <mat-divider></mat-divider>

            <div
                class="tw-whitespace-nowrap tw-flex-initial tw-text-ellipsis tw-overflow-hidden"
            >
                <span>{{ timesheetForm.controls.taskName.value }}</span>
            </div>
        </div>
        @for (day of daysOfWeek; track day) {
            <mat-form-field
                class="tw-text-xs tw-flex-1 tw-min-w-24 tw-pt-5 tw-pointer-events-none tw-opacity-50"
                appearance="outline"
                floatLabel="always"
            >
                <mat-label>
                    {{ day.abbreviation | titlecase }} {{ getDay($index) }}
                </mat-label>

                <input
                    type="number"
                    matInput
                    #hours
                    (click)="hours.select()"
                    [formControlName]="day.name"
                    onkeydown="return event.key !== 'e' && event.key !== '-' && event.key !== '+'"
                />

                <mat-icon
                    (click)="editNoteForDay(day.name)"
                    matTooltip="View Notes for Day"
                    class="hover:tw-cursor-pointer"
                    [ngClass]="{
                        'tw-text-green-500': hasNotes(day.name, timesheetForm)
                    }"
                    matSuffix
                >
                    note_add
                </mat-icon>
            </mat-form-field>
        }

        <div class="tw-self-center tw-justify-self-center">
            Task Total
            <mat-divider></mat-divider>
            {{ totalHours }}
        </div>
    </div>
</form>
